import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Typography,
  Button,
  useMediaQuery,
  useTheme,
  Stack
} from "@mui/material";
import { styled } from "@mui/material/styles";
import NotificationComponent from "../../components/atomic/NotificationComponent";

const MaintenancePageContainer = styled(Box)(({ theme }) => ({
  height: "100vh",
  width: "100vw",
  textAlign: "center",
  margin: "0 auto",
  display: "flex",
  flexDirection: "column",
  [theme.breakpoints.down("md")]: {
    height: "fit-content"
  }
}));

const StyledDivContainer = styled(Box)(({ theme }) => ({
  height: "100%",
  width: "100%",
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  [theme.breakpoints.down("lg")]: {
    flexDirection: "column",
    justifyContent: "center"
  },
  [theme.breakpoints.down("md")]: {
    alignItems: "center",
    gap: "24px"
  }
}));

const StyledLeftContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  padding: "0 0 0 5rem",
  flexDirection: "column",
  justifyContent: "center",
  width: "fit-content",
  gap: "32px",
  [theme.breakpoints.down("lg")]: {
    padding: "0 0 0 4rem",
    display: "flex",
    height: "100%",
    justifyContent: "flex-end"
  },
  [theme.breakpoints.down("md")]: {
    width: "100%",
    alignItems: "center",
    padding: "5rem 5rem 3rem"
  }
}));

const StyledContentContainer = styled(Stack)(({ theme }) => ({
  width: "100%",
  [theme.breakpoints.down("lg")]: {
    justifyContent: "flex-end"
  },
  [theme.breakpoints.down("md")]: {
    height: "fit-content",
    alignItems: "center"
  }
}));

const StyledImage = styled("img")(({ theme }) => ({
  height: "auto",
  maxWidth: "300px",
  [theme.breakpoints.down("lg")]: {
    maxWidth: "150px"
  },
  [theme.breakpoints.down("md")]: {
    maxWidth: "200px"
  }
}));

const StyledDescription = styled(Typography)(({ theme }) => ({
  color: "#00286d",
  fontFamily: "Switzer, sans-serif",
  fontSize: "2rem",
  fontStyle: "normal",
  textAlign: "left",
  fontWeight: 400,
  lineHeight: "normal",
  margin: 0,
  [theme.breakpoints.down("lg")]: {
    fontSize: "1.25rem"
  },
  [theme.breakpoints.down("md")]: {
    fontSize: "1.5rem",
    textAlign: "center",
    padding: "0 1rem"
  }
}));

const StyledDesktopBreak = styled("br")(({ theme }) => ({
  display: "none",
  [theme.breakpoints.up("lg")]: {
    display: "inline"
  }
}));

const StyledButton = styled(Button)(({ theme }) => ({
  width: "fit-content",
  display: "inline-flex",
  padding: "16px 32px",
  justifyContent: "center",
  alignItems: "center",
  gap: "4px",
  borderRadius: "32px",
  border: "none",
  cursor: "pointer",
  background: "#6692de",
  color: "#fff",
  textAlign: "center",
  fontFamily: "Switzer, sans-serif",
  fontSize: "1rem",
  fontStyle: "normal",
  fontWeight: 600,
  lineHeight: "140%",
  letterSpacing: "0.2px",
  textTransform: "capitalize",
  "&:hover": {
    opacity: 0.75,
    background: "#6692de"
  }
}));

const StyledRightContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "end",
  height: "100%",
  width: "50%",
  [theme.breakpoints.down("lg")]: {
    width: "100%",
    height: "50%",
    alignItems: "flex-end",
    justifyContent: "flex-end"
  },
  [theme.breakpoints.down("md")]: {
    width: "fit-content",
    height: "fit-content",
    alignItems: "center"
  }
}));

const StyledMaintenanceImage = styled("img")(({ theme }) => ({
  width: "auto",
  [theme.breakpoints.down("lg")]: {
    height: "100%",
    width: "auto"
  }
}));

const MaintenancePage = ({ isNotification = true }) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isTablet = useMediaQuery(theme.breakpoints.down("lg"));

  useEffect(() => {
    document.title = "Majura - Under Construction";
  }, []);

  return (
    <MaintenancePageContainer>
      {isNotification && <NotificationComponent />}
      <StyledDivContainer>
        <StyledLeftContainer>
          <StyledContentContainer spacing={3}>
            <StyledImage src="assets/img/logo_dark.png" alt={"logo"} />
            <StyledDescription>
              Your Page Request is Under {!isTablet && <StyledDesktopBreak />}{" "}
              Construction
            </StyledDescription>
            <StyledButton onClick={() => navigate("/")}>
              Go to Homepage
            </StyledButton>
          </StyledContentContainer>
        </StyledLeftContainer>

        <StyledRightContainer>
          <StyledMaintenanceImage
            src="assets/img/majura_sign_in_illustration.webp"
            alt={"Under Construction Illustration"}
          />
        </StyledRightContainer>
      </StyledDivContainer>
    </MaintenancePageContainer>
  );
};

export default MaintenancePage;
